import { computed, watch, nextTick } from "vue";
import useRouter from "@dpa-connect/dpa-id-user/compositions/useRouter";
import { validateToken } from "@dpa-connect/dpa-id-user/store/modules/auth"
import { debounce } from "lodash";
import deepEqual from "fast-deep-equal";
import store from "@/store";
import router from "@/router";
import useAuthentication from "./useAuthentication";

export default () => {
    // @ts-ignore
    const stageConfig = computed(() => store.state.stageconfig.config);
    const { isAuthenticated, token, authenticate, clearToken } = useAuthentication();
    const { query } = useRouter(router)();
  
    // eslint-disable-next-line no-shadow
    const userAuthentication = async (token: string) => {
      await authenticate({
        token,
        cert: stageConfig.value.pubKey
      });
    };
  
    const publicCombinedFilters = computed(
      () => store.getters["settings/getPublicCombinedFilters"]
    );
  
    const userCombinedFilters = computed(
      () => store.getters["settings/getUserCombinedFilters"]
    );
  
    // @ts-ignore
    const allFilters = computed(() => store.state.filters.filters);
  
    const initializeFilters = debounce(async function initializeFilters() {
      await store.dispatch("filters/fetchFilters", {
        authJWT: token.value
      });
    });
  
    const initializeSettings = () => {
      const defaultPublicCombinedFilters = publicCombinedFilters.value.length
        ? []
        : allFilters.value.filter(({ isPublic }) => isPublic === true);
      const defaultUserCombinedFilters = userCombinedFilters.value.length
        ? []
        : allFilters.value.filter(({ isPublic }) => isPublic === false);
  
      const defaultCombibedFilters = [
        ...defaultPublicCombinedFilters,
        ...defaultUserCombinedFilters
      ];
      if (defaultCombibedFilters.length) {
        store.commit("settings/setCombinedFilters", {
          filters: defaultCombibedFilters
        });
      }
    };
  
    const loadProfile = async () => {
      const valid = await authenticate({
        token: String(token.value),
        cert: stageConfig.value.pubKey
      });
      if (valid) {
        await initializeFilters();
        const profile = validateToken(token.value, "select");
        store.commit("user/setStatusSuccess", { profile });
        initializeSettings();
      }
    };
  
    /* Watchers */
    // Load user's profile once authenticated, otherwise clear the token and logout
    // @ts-ignore
    watch(
      isAuthenticated,
      debounce(async () => {
        if (
          !isAuthenticated.value &&
          !token.value &&
          !router.currentRoute.query.ticket &&
          router.currentRoute.path !== "/"
        ) {
          clearToken();
        } else if (token.value) {
          await nextTick();
          loadProfile();
        }
      }),
      { immediate: true }
    );
  
    // Sets success status if token is validated
    watch(token, (newValue, oldValue) => {
      try {
        if (stageConfig.value && token.value && !deepEqual(newValue, oldValue)) {
          // eslint-disable-next-line no-shadow
          const profile = validateToken(token.value, "select");
          store.commit("user/setStatusSuccess", { profile });
        }
      } catch (e) {
        clearToken();
      }
    });
  
    // If the JWT and stage config are present, proceed to authenticate the user
    // @ts-ignore
    watch(
      [stageConfig, query],
      () => {
        // @ts-ignore
        // eslint-disable-next-line prettier/prettier
        if (query.value?.ticket && stageConfig.value) {
          // @ts-ignore
          userAuthentication(query.value?.ticket);
        }
      },
      {
        immediate: true,
        deep: true
      }
    );
};
